import { ButtonLink } from '@poseidon/components/Input2';

type AccountExistsPanelProps = {
  email: string;
};

/**
 * POS-2510 — shown on /signup when Firebase reports the address is already registered. A
 * staff-provisioned customer lands here without knowing an account exists, so the panel says
 * so once, plainly, and offers the two ways forward. Only the email goes into the URLs.
 */
export const AccountExistsPanel = ({ email }: AccountExistsPanelProps) => {
  const encoded = encodeURIComponent(email);
  return (
    <div
      data-testid="account-exists"
      className="flex flex-col gap-3 rounded-lg border border-white/20 bg-white/10 p-4 text-left text-white">
      <p className="text-sm">
        There&apos;s already a Poseidon account for <span className="font-semibold">{email}</span>.
      </p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <ButtonLink color="blue" href={`/login?email=${encoded}`} className="justify-center">
          Log in
        </ButtonLink>
        <ButtonLink
          href={`/forget?email=${encoded}`}
          className="justify-center border-white/20 bg-white/10 text-white hover:bg-white/15">
          Set or reset your password
        </ButtonLink>
      </div>
      <p className="text-xs text-white/60">
        If someone at Poseidon set your account up for you, use <em>Set or reset your password</em>.
      </p>
    </div>
  );
};
